module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1a_Image6c.f8f07a77.jpg";